export default {
	articleEditDialog: {
		title: "Articolo {articleId} - Impostazioni",
		articleNameLabel: "Nome articolo",
		articleNumberLabel: "Numero articolo",
		articleNumberPlaceholder: "Il Suo numero articolo",
		articleNumberHint:
			"Può assegnare a ogni articolo un proprio numero articolo. Il numero appare anche sul bollettino di consegna e sulla fattura.",
		materialLabel: "Materiale",
		deburringLabel: "Sbavatura:",
		migratedHint: "Blexonizzi l'articolo per modificare la sbavatura.",
		deburringPlaceholder: "Selezioni il tipo di sbavatura...",
		werkstoffChangedHint:
			"Se si desidera modificare il materiale, l'articolo deve prima essere ricalcolato prima di poter adeguare il tipo di sbavatura. A tale scopo, salvi le modifiche attuali e attenda che l'articolo sia stato convalidato.",
		deburringInfoTooltip: "Informazioni sulla sbavatura di parti metalliche",
		close: "Chiudi",
		saveMaterialTooltip: "Salva il materiale.",
		saveArticleTooltip: "Salva l'articolo con i dati indicati.",
		saveFailedError: "Non è stato possibile salvare i dati. {error}",
		saveMaterialFailedError: "Non è stato possibile modificare il materiale. {error}",
	},
	articleDeleteWarningDialog: {
		title: "Attenzione!",
		inCartsText: "L'articolo verrà eliminato anche dalle seguenti distinte base:",
		confirmDelete: "Vuole davvero eliminare l'articolo?",
		weldedText:
			"Questo articolo non può essere eliminato poiché è saldato ad altri articoli di questo assieme.",
		delete: "Elimina",
		messages: {
			deleteError: "Non è stato possibile eliminare l'articolo.",
		},
	},
	articleMultiDeleteDialog: {
		title: "Elimina più articoli",
		deletedProgress: "{deleted} di {total} eliminati",
		lockedArticlesText:
			"I seguenti articoli sono bloccati oppure sono attualmente in fase di calcolo e pertanto {not} possono essere eliminati:",
		lockedArticlesTextBold: "non",
		partOfCartsText: "I seguenti articoli fanno parte di almeno una distinta base:",
		containedIn: "Contenuto in...",
		confirmDeleteCount: "Vuole davvero eliminare {count} articoli?",
		noneCanBeDeleted: "Nessuno degli articoli selezionati può essere eliminato.",
		delete: "Elimina",
		messages: {
			deleteError: "Errore durante l'eliminazione di un articolo.",
		},
	},
	articlePriceInfoDialog: {
		title: "Il prezzo finale, sconto quantità incluso, è visibile nel carrello.",
		intro:
			"Il listino prezzi serve ai progettisti per una rapida stima dei prezzi e si applica all'ordinazione di questo singolo articolo (lotto omogeneo).",
		explanation:
			"Per calcolare il prezzo finale, componga un carrello e ottenga in pochi secondi un'offerta comprensiva della data di consegna.",
		discountExplanation:
			"Nel calcolo dell'offerta vengono considerati tutti gli articoli inclusi e viene calcolato uno sconto specifico per l'ordine (sconto d'ordine).",
		discountHighlight:
			"Più articoli con le stesse lavorazioni o con lo stesso materiale comportano una riduzione di prezzo.",
		factorsIntro: "I seguenti fattori portano a una {reduction}",
		factorsReductionBold: "riduzione di prezzo:",
		factor1: "Più articoli ricavati dallo stesso materiale grezzo (stesso materiale e stesso spessore della lamiera)",
		factor2:
			"Più articoli con le stesse lavorazioni (filettature, svasature ed estrusioni) nello stesso materiale grezzo",
		factor3: "Più articoli con la stessa verniciatura a polvere (stessa polvere)",
		factor4: "Più articoli con la stessa zincatura",
		priceNote:
			"Il prezzo si intende IVA esclusa, sconti specifici dell'ordine, imballaggio e consegna esclusi.",
		close: "Chiudi",
	},
	articleTreatmentEditDialog: {
		closeTooltip: "Chiude la finestra di dialogo.",
		notAvailableTitle: "Verniciatura a polvere",
		notAvailableText: "La verniciatura a polvere degli articoli non è purtroppo ancora disponibile nella Sua regione.",
		titleSingle: "Verniciatura a polvere - Articolo '{name}' ({id})",
		titleMultiple: "Verniciatura a polvere - {count} articoli",
		standardColorsHint: "Vengono mostrati solo i colori standard senza sovrapprezzo.",
		showAllColorsLabel: "Mostra tutti i colori",
		ralSearchLabel: "Cerca colore RAL",
		structureLabel: "Struttura",
		finishLabel: "Finitura",
		powderSelectionHeading: "Selezione della polvere:",
		standardNoSurchargeSuffix: " (Standard senza sovrapprezzo)",
		noPowderAvailable: "Nessuna polvere disponibile con il filtro attuale",
		nonStandardPowderInfo1: "Questa polvere non fa parte dell'assortimento standard e deve essere ordinata.",
		nonStandardPowderInfo2:
			"Viene applicato un sovrapprezzo una tantum di {cost}. In caso di più posizioni in questo colore, il sovrapprezzo viene addebitato una sola volta, in quanto viene considerato nello sconto d'ordine.",
		nonStandardPowderInfo3:
			"Tenga presente che ciò può comportare anche un allungamento dei tempi di consegna.",
		faceLabel: "Superficie",
		baseCoatingLabel: "Preprimer: offre protezione anticorrosione",
		warningText1:
			"Nella verniciatura a polvere si deve considerare uno {thickness}. Progetti eventuali fori e ritagli di conseguenza più grandi. {gewinde} vengono coperte prima della verniciatura e non devono essere adeguate. {senkungen} non vengono coperte, tuttavia lo spessore dello strato viene compensato durante la produzione.",
		warningThicknessBold: "spessore dello strato di ca. 0,1mm",
		warningGewindeBold: "Le filettature",
		warningSenkungenBold: "Le svasature",
		warningTextOneSided:
			"Inoltre va considerato che, in caso di verniciatura su un solo lato, il lato opposto non viene coperto e pertanto si deve prevedere una {spray} su questo lato.",
		warningSprayBold: "nebbia di spruzzo",
		warningText2:
			"{achtung} La sola verniciatura a polvere non offre {noCorrosion}. Le {steelParts} verniciate a polvere non sono quindi {notOutdoor}, a meno che non venga eseguito un {primer}. Si tratta di un rivestimento supplementare che offre una protezione anticorrosione per le parti in acciaio. Le parti verniciate a polvere in acciaio inossidabile o alluminio sono adatte per l'uso esterno o per luoghi con elevata umidità, purché non siano presenti condizioni ambientali estreme. In caso di condizioni climatiche estreme e in ambienti con elevata umidità ed elevato contenuto di sale nell'aria, anche per l'alluminio dovrebbe essere scelto un preprimer. In caso di domande o incertezze, non esiti a contattare il nostro helpdesk.",
		warningAchtungBold: "Attenzione:",
		warningNoCorrosionBold: "nessuna protezione anticorrosione",
		warningSteelPartsBold: "parti in acciaio",
		warningNotOutdoorBold: "adatte per l'uso esterno o per luoghi con elevata umidità",
		warningPrimerBold: "preprimer",
		close: "Chiudi",
		removeTooltipSingle: "Rimuove la verniciatura a polvere dall'articolo.",
		removeTooltipMultiple: "Rimuove la verniciatura a polvere da tutti gli articoli.",
		removeButton: "Rimuovi",
		saveTooltipSingle: "Salva la verniciatura a polvere.",
		saveTooltipMultiple: "Salva la verniciatura a polvere per tutti gli articoli.",
		finishOptions: {
			all: "Tutte",
			matt: "Opaco",
			glossy: "Lucido",
		},
		structureOptions: {
			all: "Tutte",
			smooth: "Liscia",
			fine: "Fine",
			rough: "Grezza",
		},
		faceOptions: {
			top: "Lato superiore",
			bottom: "Lato inferiore",
			both: "Su entrambi i lati",
		},
		messages: {
			loadPowdersError: "Non è stato possibile caricare le polveri.",
			loadMaterialIdsError: "Non è stato possibile caricare gli ID dei materiali.",
			saveError: "Non è stato possibile salvare il trattamento superficiale dell'articolo {articleId}.",
			saveSuccess: "Il trattamento superficiale è stato salvato.",
			deleteError: "Non è stato possibile eliminare il trattamento superficiale dell'articolo {articleId}.",
			deleteSuccess: "Il trattamento superficiale è stato eliminato.",
		},
	},
	articleZincCoatingEditDialog: {
		analyzingTitle: "Analisi della zincatura in corso...",
		close: "Chiudi",
		titleSingle: "Zincatura - Articolo '{name}' ({id})",
		titleMultiple: "Zincatura - {count} articoli",
		errorIntroSingle: "Una zincatura non è possibile per questo articolo per il seguente motivo:",
		errorIntroMultiple: "Una zincatura non è possibile per gli articoli elencati:",
		hotDipLabel: "Zincatura a caldo",
		thicknessLabel: "Spessore dello strato: ",
		hotDipThicknessValue: "50-150µm",
		galvanizeThicknessValue: "5-20µm",
		moreInfo: "Maggiori informazioni",
		hotDipInfoText:
			"Nella zincatura a caldo, i componenti vengono immersi in un bagno di zinco a una temperatura di circa 450 °C. Questa temperatura elevata genera tensioni nei componenti. Per questo motivo è molto importante una progettazione adeguata delle parti da zincare. Nei componenti chiusi (ad es. scatole saldate), devono essere previste delle aperture. Queste consentono da un lato la fuoriuscita dell'aria che si dilata durante il riscaldamento e dall'altro il deflusso dello zinco in eccesso al momento dell'estrazione dal bagno fuso. Inoltre, le lamiere sottili (spessore < 4mm) di norma non sono adatte alla zincatura a caldo, poiché possono deformarsi notevolmente sotto l'effetto del calore.",
		hotDipNotPossibleSingle: "La zincatura a caldo non è disponibile per questo materiale.",
		assemblyHint:
			"Gli assiemi possono essere zincati solo se tutti i sottoarticoli consentono questo tipo di zincatura.",
		hotDipNotPossibleMultiple:
			"La zincatura a caldo non è disponibile per questa combinazione di materiali. Provi a zincare gli articoli singolarmente.",
		hotDipPowderCoatedConflict:
			"Blexon al momento non offre la combinazione di zincatura a caldo e verniciatura a polvere.",
		threadsNotHotDippable: "Gli articoli con filettature o estrusioni non possono essere zincati a caldo.",
		galvanizeLabel: "Zincatura galvanica",
		galvanizeInfoText:
			"A differenza della zincatura a caldo, nella zincatura galvanica i componenti non vengono immersi in un bagno di zinco fuso, bensì in un elettrolita di zinco. In questo processo, un elemento di zinco funge da anodo e la parte in acciaio da rivestire da catodo. Questo procedimento genera meno calore ed è quindi adatto a lamiere più sottili. Per applicazioni esterne durature, tuttavia, lo spessore dello strato di zinco è spesso troppo sottile.",
		galvanizeNotPossibleSingle: "La zincatura galvanica non è disponibile per questo materiale.",
		galvanizeNotPossibleMultiple:
			"La zincatura galvanica non è disponibile per questa combinazione di materiali. Provi a zincare gli articoli singolarmente.",
		sendToHelpdesk: "Invia all'helpdesk",
		removeTooltipSingle: "Rimuove la zincatura dall'articolo.",
		removeTooltipMultiple: "Rimuove la zincatura da tutti gli articoli.",
		removeButton: "Rimuovi",
		saveTooltipSingle: "Salva la zincatura.",
		saveTooltipMultiple: "Salva la zincatura per tutti gli articoli.",
		messages: {
			loadError: "Non è stato possibile caricare i dati di zincatura.",
			saveError: "Non è stato possibile salvare la zincatura dell'articolo {articleId}.",
			saveSuccess: "La zincatura è stata salvata.",
		},
	},
	certificateHelperDialog: {
		title: "Certificato / Attestati",
		text1:
			"Dopo la consegna dei pezzi, può scaricare un certificato di collaudo 3.1 secondo la norma EN 10204:2004 nel Suo archivio ordini.",
		text2: "L'attestato proviene dal produttore della materia prima e non comprende alcuna attestazione di ritrascrizione da parte del trasformatore di lamiera.",
		close: "Chiudi",
	},
	isPowdercoatingPossibleDialog: {
		analyzingTitle: "Analisi della verniciatura a polvere in corso...",
		notPossibleTitle: "Verniciatura a polvere non selezionabile",
		possibleTitle: "Verniciatura a polvere possibile",
		reasonIntroSingle: "Una verniciatura a polvere non è possibile per questo articolo per il seguente motivo:",
		reasonIntroMultiple: "Una verniciatura a polvere non è possibile per gli articoli elencati:",
		sendToHelpdesk: "Invia all'helpdesk",
		close: "Chiudi",
		messages: {
			determineError: "Non è stato possibile determinare se l'articolo può essere verniciato a polvere.",
		},
	},
	sendToHelpdeskDialog: {
		title: "Invia l'articolo all'helpdesk Blexon",
		text1:
			"Sta inviando questo articolo all'helpdesk Blexon. Verificheremo la causa dei messaggi di errore e, se possibile, la risolveremo. Saremo lieti di fornirLe anche indicazioni su come modificare la costruzione affinché l'articolo diventi realizzabile.",
		freeService: "Questo servizio è gratuito.",
		text2:
			"Verrà informato via e-mail non appena l'articolo sarà stato elaborato. La verifica avviene di norma entro alcune ore durante l'orario di apertura.",
		text3:
			"Tenga presente che dopo l'invio l'articolo non può più essere modificato né eliminato finché non viene approvato da Blexon.",
		emailLabel: "E-mail per le notifiche relative a questo articolo",
		sendButton: "Invia",
		sendTooltip: "Invia l'articolo all'helpdesk per un chiarimento.",
		abortDialogTitle: "Non inviare l'articolo",
		abortDialogText:
			"Vuole davvero annullare questa azione? L'articolo non verrà inoltrato all'helpdesk Blexon.",
		abortConfirmButton: "Non inviare",
		abortConfirmTooltip: "Annulla l'azione senza inviare l'articolo all'helpdesk.",
		messages: {
			sendSuccess: "L'articolo è stato inviato all'helpdesk.",
			sendError: "Non è stato possibile inviare l'articolo all'helpdesk. Si rivolga a info@blexon.com.",
		},
	},
	tooManyCalculatingDialog: {
		title: "Troppi calcoli simultanei",
		text1: "Può blexonizzare fino a 10 articoli contemporaneamente.",
		text2:
			"I calcoli richiedono molto tempo e molte risorse. Per questo motivo limitiamo il numero di calcoli simultanei per proteggere i nostri server e distribuire equamente le prestazioni tra tutti i clienti.",
		text3: "La preghiamo di attendere che alcuni calcoli siano terminati. Grazie per la comprensione.",
		close: "Chiudi",
	},
	speechBubbleFloat: {
		dontShowAgain: "Non mostrare più questo messaggio",
	},
};
